<template>
  <div class="container" :style="'height:'+containerHeight+'px'">
    <div v-if="!isLoading" class="content">
      <div class="details flex-row-center"
           v-if="info.details">
        <div class="info flex-row-start">
          <img :src="goodsInfo.imgUrl"
               alt="" />
          <div>
            <p class="name">{{ goodsInfo.goodsName }}</p>
            <p class="desc">{{ goodsInfo.goodsTitle }}</p>
            <p>
              <span class="buy-number">{{ goodsInfo.peopleBuyNumber }}</span><span>人购买</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isLoading" class="inforBBox">
      <div class="price">￥{{ goodsInfo.companyGoodsPrice }}</div>
      <div class="flex-row-start">
        <div class="nav-top-center flex-column-center cursor-pointer"
             v-for="(item, index) in tabs"
             :key="index"
             @click="navTo(item, index)">
          <span :class="[selectTab == index ? 'select' : '']">{{
            item.name
          }}</span>
        </div>
      </div>

      <div v-if="selectTab == 1"
           class="course-details">
        <img v-for="item in courseIntroduce" :src="item"
             alt="">
      </div>

      <div v-if="selectTab == 0"
           class="courses">
        <!-- <a-tree :replace-fields="replaceFields"
                :tree-data="goodsChapterList"
                @select="treeSelect" /> -->

          <a-directory-tree default-expand-all @select="treeSelect">
            <a-tree-node :key="item.autoId" :title="item.subsectionName" v-for="(item) in goodsChapterList" :isLeaf="false" >
              <a-tree-node :key="subItem.autoId" :title="subItem.subsectionName" is-leaf v-for="(subItem) in item.goodsSubsectionList" :isLeaf="true" />
            </a-tree-node>
          </a-directory-tree>

      </div>
    </div>
    <div v-if="!isLoading" class="footer">
      <custom-footer></custom-footer>
    </div>

    <a-spin size="large"
            v-if="isLoading"
            tip="加载中..." />
  </div>
</template>

<script>
import CustomFooter from '../../components/globalComponents/Footer.vue'
import GoodsDetails from '../../assets/datas/GoodsDetails.json'

import { courseDetail } from "../../assets/api/api";
export default {
  name: 'GoodsDetails',
  components: {
    CustomFooter,
  },
  data () {
    return {
      info: {},
      selectTab: 0,
      tabs: [
        {
          name: '听课目录',
        },
        {
          name: '课程介绍',
        },
      ],
      replaceFields: {
        children: 'goodsSubsectionList',
        title: 'subsectionName'
      },
      courseId: '',
      goodsInfo: {},
      courseIntroduce: '',
      goodsChapterList: [],
      isLoading: true,
      containerHeight: 0
    }
  },
  mounted () {
    this.containerHeight = document.documentElement.clientHeight - 80
     this.$message.config({
      top: `400px`,
      duration: 2,
      maxCount: 1,
    });
    this.courseId = this.$route.query.courseId
    this.fatchData()
  },
  beforeDestroy () {
    this.$message.destroy()
  },
  methods: {
    fatchData () {
      this.info = GoodsDetails
      this.courseDetail()
    },
    courseDetail () {
      const params = {
        uId: localStorage.getItem('userId'),
        gId: this.courseId
      }
      courseDetail(params).then(res => {
        this.goodsInfo = res.data.goodsInfo
        this.courseIntroduce = res.data.courseIntroduce
        res.data.goodsChapterList.forEach(element => {
          element.subsectionName = element.chapterName.replace(/&nbsp;/ig, "")
          element.goodsSubsectionList.forEach(ele => {
            ele.subsectionName =  ele.subsectionName.replace(/&nbsp;/ig, "")
          })
        });
        this.goodsChapterList = res.data.goodsChapterList
      }).catch((err) => {
      }).finally(() => {
        this.isLoading = false
      })
    },
    navTo (item, index) {
      if (this.selectTab == index) return
      this.selectTab = index
    },
    treeSelect (selectedKeys, e) {
      if(!e.selectedNodes[0].isLeaf) {
        return
      }
      if(!this.goodsInfo.ifBuy) {
        this.$message.warning('请联系老师购买课程');
        return
      }

      this.$router.push({ name: 'GoodsPlay', query: { subId: selectedKeys[0], goodsId: this.courseId } })
    }
  },
}
</script>

<style scoped lang="scss">
 /deep/ .ant-tree li span.ant-tree-iconEle {
  display: none;
}
/deep/ .ant-tree {
  font-size: 16px !important;
}
.container {
  overflow-y: auto;
  display: block;
  .content {
    width: 100%;
    // min-height: calc(100% - 1.68rem);
    .details {
      background: url("../../assets/images/goodsBanner.png") no-repeat;
      background-size: 100% 450px;
      height: 450px;
      width: 100%;
      .info {
        width: 1200px;
        font-size: 22px;
        color: #fff;
        align-items: flex-start;
      }
      img {
        width: 480px;
        height: 243px;
        margin-right: 90px;
        object-fit: cover;
      }

      .name {
        font-size: 24px;
        color: #fff;
        font-weight: 700;
        margin: 30px 0 20px;
        line-height: 1.1;
      }

      .desc {
        font-size: 18px;
        color: #fffefe;
        margin-bottom: 20px;
      }

      .buy-number {
        color: #ff3934;
      }
    }
  }

  .inforBBox {
    width: 1200px;
    min-height: 800px;
    display: -webkit-box;
    display: -ms-flexbox;
    padding: 20px 30px 0;
    -webkit-box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.14);
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.14);
    margin: 0 auto 20px;
    margin-top: -50px;
    background-color: #ffffff;
    border-radius: 10px;
    .price {
      font-size: 40px;
      color: #ffa200;
    }

    .nav-top-center {
      width: 140px;
      font-size: 22px;
      span {
        line-height: initial;
        border-bottom: 4px solid #ffffff;
        line-height: 50px;
      }
      .select {
        border-bottom: 4px solid #2d78c5;
        font-size: 22px;
        color: #2d78c5;
      }
    }

    .course-details {
      img {
        width: 100%;
        height: auto;
        padding: 50px;
        box-sizing: border-box;
      }
    }

    .courses {
      width: 100%;
      height: auto;
      padding: 30px 0;
      box-sizing: border-box;
    }
  }
  .footer {
    width: 100%;
  }
}
</style>
